import styled from 'styled-components';

export default styled.div`
  width: 100%;
  height: 1px;
  opacity: 0.2;
  background-color: var(--primary200);
`;
